import React from 'react';
import {Text, View} from '@lookiero/aurora';
import {style} from './Row.styles';
import {ViewStyle} from 'react-native';

interface RowProps {
  title: string;
  content: React.ReactNode;
  style?: ViewStyle;
}

export const Row: React.FC<RowProps> = ({title, content, style: rowStyle}) => (
  <View style={rowStyle}>
    <Text detail level={2} style={style.title}>
      {title}
    </Text>
    <Text action level={3} style={style.rowContent}>
      {content}
    </Text>
  </View>
);
